import React, { useState } from 'react';
import { useTenant } from '../context/TenantContext';
import { useNavigate } from 'react-router-dom';
import {
  Container, Box, Typography, TextField, Button, Alert,
  CircularProgress, Card, CardContent,
} from '@mui/material';
import { PersonAdd, CheckCircle } from '@mui/icons-material';
import PublicHeader from '../components/PublicHeader';
import Footer from '../components/Footer';

const API = process.env.REACT_APP_API_URL || 'https://api.conectachurch.com.br';
const PURPLE = '#00F1A7';

export default function TenantCadastro() {
  const tenant = useTenant();
  const navigate = useNavigate();
  const [form, setForm] = useState({ nome: '', email: '', telefone: '' });
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.nome || !form.email) {
      setErro('Nome e email são obrigatórios');
      return;
    }
    setLoading(true);
    setErro('');
    try {
      await fetch(`${API}/saas/igrejas/${tenant.id}/cadastro-usuario`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      setSuccess(true);
    } catch {
      setErro('Erro ao enviar cadastro. Tente novamente.');
    }
    setLoading(false);
  };

  if (!tenant) {
    return (
      <Container maxWidth="sm" sx={{ py: 10, textAlign: 'center' }}>
        <Typography variant="h5">Igreja não encontrada</Typography>
        <Button onClick={() => navigate('/')} sx={{ mt: 2 }}>Voltar ao início</Button>
      </Container>
    );
  }

  return (
    <>
      <PublicHeader />
      <Box sx={{ minHeight: '80vh', display: 'flex', alignItems: 'center', py: 4, bgcolor: '#f8f9fa' }}>
        <Container maxWidth="sm">
          <Card sx={{ borderRadius: 3, p: { xs: 3, md: 5 } }} elevation={2}>
            {success ? (
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <CheckCircle sx={{ fontSize: 64, color: '#10B981', mb: 2 }} />
                <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>Cadastro enviado!</Typography>
                <Typography color="text.secondary">
                  Seu cadastro em <strong>{tenant.nome}</strong> será analisado por um administrador.
                  Você receberá um email quando for aprovado.
                </Typography>
                <Button onClick={() => navigate(`/t/${tenant.slug}/login`)} variant="outlined" sx={{ mt: 3 }}>
                  Ir para o login
                </Button>
              </Box>
            ) : (
              <>
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                  <PersonAdd sx={{ fontSize: 48, color: PURPLE, mb: 1 }} />
                  <Typography variant="h5" sx={{ fontWeight: 700 }}>Cadastro</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {tenant.nome}
                  </Typography>
                </Box>

                {erro && <Alert severity="error" sx={{ mb: 2 }}>{erro}</Alert>}

                <Box component="form" onSubmit={handleSubmit}>
                  <TextField fullWidth label="Nome completo" value={form.nome}
                    onChange={e => setForm(f => ({ ...f, nome: e.target.value }))} sx={{ mb: 2 }} required />
                  <TextField fullWidth label="Email" type="email" value={form.email}
                    onChange={e => setForm(f => ({ ...f, email: e.target.value }))} sx={{ mb: 2 }} required />
                  <TextField fullWidth label="Telefone" value={form.telefone}
                    onChange={e => setForm(f => ({ ...f, telefone: e.target.value }))} sx={{ mb: 3 }} />
                  <Button type="submit" fullWidth variant="contained" disabled={loading}
                    sx={{ bgcolor: PURPLE, color: '#fff', fontWeight: 700, py: 1.5 }}>
                    {loading ? <CircularProgress size={20} color="inherit" /> : 'Enviar cadastro'}
                  </Button>
                </Box>

                <Typography variant="body2" sx={{ textAlign: 'center', mt: 2 }}>
                  Já tem acesso?{' '}
                  <Box component="span" onClick={() => navigate(`/t/${tenant.slug}/login`)}
                    sx={{ color: PURPLE, fontWeight: 700, cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}>
                    Fazer login
                  </Box>
                </Typography>
      <Footer />
    </>
            )}
          </Card>
        </Container>
      </Box>
    </>
  );
}
